import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../../parts/crud/Types'
import moment from 'moment'
import { useState, useEffect } from 'react'

export const WidgetDeviceEventsComparison = (props:any) => {
  const intl = useIntl()
  const days = props && props.days ? props.days : 7
  let params: any = {
    title: intl.formatMessage({id: 'REPORT_DEVICE.COMPARISON.TITLE'}),
    subtitle:  intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', days) ,
    yAxisTitle: intl.formatMessage({id: 'REPORT_DEVICE.COMPARISON.YAXISTITLE'}),
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}

   const [filterData, setFilterData] = useState<any>({});
  
    useEffect(() => {
      const newFilterData =  {
        server: 'all',
        top: 20,
        tz: new Date().getTimezoneOffset(),
        date_range: {
          start: moment().subtract(days, 'days'),
          end: moment(),
        },
      }
      setFilterData(newFilterData);
    }, [days]); 
  /*
  const filterData = {
    server: 'all',
    top: 20,
    tz: new Date().getTimezoneOffset(),
    date_range: {
      start: moment().subtract(days, 'days'),
      end: moment(),
    },
  }
    */

  if(!filterData || Object.keys(filterData).length===0){
    return <></>
  }
  return (
    <>
      <CrudProvider api='reports/comparison'>
        <ChartsComponent
          disableError={true}
          filterData={filterData}
          chartOnly='true'
          baseChartOptions={baseChartOptions}
        ></ChartsComponent>
      </CrudProvider>
    </>
  )
}
